import Profile from "./Profile";
import ListMenu from "./ListMenu";

export default {
    Profile,
    ListMenu
}